export default __webpack_public_path__ + "static/media/business_image.726dffe8.png";